import React, { useState, useEffect } from "react";
import {
  Container,
  InputDiv,
  LeftSide,
  RightSide,
  SubTitle,
  TitleSlot,
  RightBody,
  RightFooter,
  TaskDescription,
  InputSlot,
  Counter,
  BoxLoader,
} from "./styles";
import Search from "../../../../assets/icons/Search";
import Iterable from "./Iterable";
import GreenFlash from "../../../../assets/icons/GreenFlash";
import Flash from "../../../../assets/icons/Flash copy";
import Input from "../../Input/index";
import Button from "../../Button/index";
import GlobalStyle from "../../../../styles/globalStyles";
import ActiveNewFlowModal from "../../Modal/index";
import ReactLoading from "react-loading";
import { useDispatch, useSelector } from "react-redux";
import { handleListProjects } from "../../../../state/flows/actions";
import { toastAlert } from "../../../Toastify/index";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import { closeModal } from "../../../../state/zaivuPersist/slice";
import { ConfirmActiveModal } from "./ConfirmActiveFlowModal";
import { handleAddActivedFlow } from "../../../../state/activedFlows/actions";
import { ConfirmationModal } from "./ConfirmationModal";
import { useHistory } from "react-router-dom";

const NewFlowModal = () => {
  const [flowName, setFlowName] = useState("");
  const [flowClient, setFlowClient] = useState("");
  const [taskDescriptionText, setTaskDescriptionText] = useState("");
  const [selected, setSelected] = useState({
    title: "",
    _id: "",
  });

  const [newFlow, setNewFlow] = useState(null);

  const isOpen = useSelector((state) => state.zaivuPersist.menu.isModalOpen);
  const history = useHistory();

  const user = useSelector((state) => state.auth.user);
  const [openFlow, setOpenFlow] = useState("");
  const [FlowList, setFlowList] = useState([]);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  const toSearch = (searchTerm) => (item) =>
    item.main.title.toLowerCase().includes(searchTerm.toLowerCase());

  const SearchList = FlowList.filter(toSearch(search));

  const [modal, setModal] = useState({ toConfirm: false, afterConfirm: false });

  const [errors, setErrors] = useState({
    title: false,
    client: false,
    description: false,
    selected: false,
  });

  const onClose = () => dispatch(closeModal());

  const closeAll = async () => {
    setModal({ toConfirm: false, afterConfirm: false });
    dispatch(closeModal());
  };

  const { promiseInProgress } = usePromiseTracker({ area: "list-flows" });

  const resetState = () => {
    setFlowName("");
    setFlowClient("");
    setTaskDescriptionText("");
    setSelected({ title: "", _id: "" });
    setOpenFlow("");
    setErrors({ title: false, client: false, description: false });
    setSearch("");
  };

  async function fetchList() {
    if (!user?._id) {
      onClose();
    }
    if (isOpen) {
      trackPromise(
        dispatch(handleListProjects(user._id))
          .then((res) => {
            setFlowList(res.data.projects);
          })
          .catch((err) => {
            toastAlert({
              msg: `Ocorreu um erro ao carregar os fluxos: ${err}`,
              isError: true,
            });
          }),
        "list-flows"
      );
    }
  }

  async function activateFlow() {
    trackPromise(
      dispatch(
        handleAddActivedFlow({
          flowId: selected._id,
          tenantId: user._id,
          title: flowName,
          client: flowClient,
          description: taskDescriptionText,
        })
      )
        .then((res) => {
          onClose(); //Fecha o Modal Principal
          setNewFlow(res.payload.flow);
          toastAlert({ msg: `Fluxo '${flowName}' iniciado com SUCESSO!` });
          setModal({ toConfirm: false, afterConfirm: true }); //Abre o modal de push
        })
        .catch((err) => {
          console.log(err);
          closeAll(); //Fecha todos os Modais
          toastAlert({
            msg: `Ocorreu um ERRO ao tentar iniciar o fluxo '${flowName}': ${err.response.data.error}`,
            isError: true,
          });
        }),
      "activate-flow"
    );
  }

  function handlePushToNewFlow(flowId) {
    closeAll();
    history.push({
      pathname: "/workflow/",
      state: "active",
      search:
        "?" +
        new URLSearchParams({
          flowId,
        }).toString(),
    });
  }

  function handleValidation() {
    let errors = {
      title: false,
      client: false,
      description: false,
      selected: false,
    };

    if (flowName === "") errors = { ...errors, title: true };
    if (flowClient === "") errors = { ...errors, client: true };
    if (taskDescriptionText === "") errors = { ...errors, description: true };

    if (selected._id === "") {
      toastAlert({
        msg: `É necessário SELECIONAR um fluxo modelo para prosseguir`,
        isError: true,
      });
      errors = { ...errors, selected: true };
    }

    return errors;
  }

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchList();
    }

    if (!isOpen) resetState();

    return () => {
      isMounted = false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <>
      <ActiveNewFlowModal isOpen={isOpen} onClose={onClose}>
        <GlobalStyle />
        <Container>
          <LeftSide>
            <TitleSlot>
              <GreenFlash width="1rem" />
              <span>Iniciar Novo Fluxo</span>
            </TitleSlot>
            <SubTitle>
              Ative um modelo de fluxo pré-definido e delegue as tarefas para
              colaboradores e equipes.
            </SubTitle>

            <InputDiv>
              <Input
                error={errors.title}
                errorMsg="Digite um nome válido para o fluxo"
                value={flowName}
                setValue={(e) => {
                  setFlowName(e);
                }}
                label="Nome do Fluxo"
                placeholder={"Projeto Casa - Almir Ferreira"}
                type="text"
              />
            </InputDiv>
            <InputDiv>
              <Input
                error={errors.client}
                errorMsg="Digite um nome válido para o cliente"
                value={flowClient}
                setValue={(e) => {
                  setFlowClient(e);
                }}
                label="Cliente"
                type="text"
                placeholder={"Almir Ferreira"}
              />
            </InputDiv>

            <TaskDescription error={errors.description}>
              <span>Descrição</span>
              <textarea
                maxLength={150}
                name="TaskDescriptionArea"
                type="text"
                id="CommentsOrAdditionalInformation"
                value={taskDescriptionText}
                onChange={(e) => setTaskDescriptionText(e.target.value)}
              ></textarea>
            </TaskDescription>
            <Counter> {taskDescriptionText.length}/150</Counter>
          </LeftSide>
          <RightSide>
            <span className="right-title">Selecione o Modelo</span>
            <span className="sub-title">
              Escolha o modelo e a versão que deseja para ativar um novo fluxo.
            </span>
            <InputSlot>
              <Input
                Icon={() => <Search />}
                placeholder="Pesquisar por Titulo..."
                value={search}
                setValue={setSearch}
              />
            </InputSlot>
            <RightBody>
              {!promiseInProgress ? (
                <>
                  {FlowList.length > 0
                    ? SearchList.map((item, index) => (
                        <Iterable
                          setFlowList={setFlowList}
                          key={index + Math.random()}
                          project={item}
                          onSelect={setSelected}
                          selected={selected}
                          openFlow={openFlow}
                          setOpenFlow={setOpenFlow}
                        />
                      ))
                    : "Não há modelos criados"}
                </>
              ) : (
                <BoxLoader>
                  <ReactLoading type="bars" color="#118052" />
                </BoxLoader>
              )}
            </RightBody>
            <RightFooter>
              <Button
                Icon={() => <Flash />}
                content={"Iniciar Fluxo"}
                onClick={() => {
                  const getErrors = handleValidation();
                  setErrors(getErrors);

                  if (
                    !getErrors.title &&
                    !getErrors.client &&
                    !getErrors.description &&
                    !getErrors.selected
                  ) {
                    setModal({ toConfirm: true, afterConfirm: false });
                  }
                }}
                width={"10rem"}
              />

              <Button
                outline
                content={"Cancelar"}
                onClick={onClose}
                width={"7.25rem"}
              />
            </RightFooter>
          </RightSide>
        </Container>
      </ActiveNewFlowModal>
      <ConfirmActiveModal
        name={flowName}
        description={taskDescriptionText}
        client={flowClient}
        flow={selected}
        onConfirm={activateFlow}
        isOpen={modal.toConfirm}
        onClose={() => setModal({ toConfirm: false, afterConfirm: false })}
      />
      <ConfirmationModal
        flow={newFlow}
        onConfirm={() => {
          handlePushToNewFlow(newFlow.flowId);
        }}
        isOpen={modal.afterConfirm}
        onClose={closeAll}
      />
    </>
  );
};

export default NewFlowModal;
